/**
 * EasyWork-Produktlinien – für „Geeignet für“ an E-Mail-Vorlagen.
 * Schlüssel identisch zu backend/routes/templates.py (GEEIGNET_FUER).
 */
export const PRODUKTLINIEN = [
  { key: 'bi', label: 'EasyWork BI' },
  { key: 'family', label: 'EasyWork Family' },
  { key: 'gastro', label: 'EasyWork Gastro' },
  { key: 'immo', label: 'EasyWork Immo' },
  { key: 'legal', label: 'EasyWork Legal' },
  { key: 'mitglieder', label: 'EasyWork Mitglieder+' },
  { key: 'sonstige', label: 'Sonstige' },
];

export const produktlinieLabel = (key) => PRODUKTLINIEN.find((p) => p.key === key)?.label || key;

/**
 * Produktlinien des eingeloggten Mandanten aus Mandantentyp und aktiven Branchen ableiten.
 * Ein Mandant kann mehrere haben (z. B. EasyWork BI mit Branche Immobilien → bi + immo).
 */
export function ermittleProduktlinien(user, aktiveBranchen = []) {
  const typ = (user?.tenant_type || '').toLowerCase();
  const out = new Set();
  if (typ === 'legal') out.add('legal');
  else if (typ === 'gastro') out.add('gastro');
  else if (typ === 'family') out.add('family');
  else if (['mitglieder_plus', 'verein', 'sportverein'].includes(typ)) out.add('mitglieder');
  else out.add('bi');
  if ((aktiveBranchen || []).some((b) => /immobil/i.test(String(b)))) out.add('immo');
  return [...out];
}

/** Passt die Vorlage zur Produktlinie des Mandanten? (ohne Angabe → neutral = false) */
export const passtZuMandant = (template, produkte) =>
  Array.isArray(template?.geeignet_fuer) && template.geeignet_fuer.some((k) => produkte.includes(k));
